import styled from 'styled-components'
import { Icon } from 'components'

const rand = (max) => {
  return Math.floor(Math.random() * max)
}

const getRandColor = () => {
  const colors = [
    'link',
    'accent',
    'highlight',
    'success',
    'warning',
    'danger'
  ]
  return colors[Math.floor(Math.random() * colors.length)]
}

const Circle = styled.div`
  ${({ theme: { colors, breakpoint } }) => `
  border-radius: 50%;
  background: ${colors(getRandColor())};
  width: 5rem;
  height: 5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 1rem;
  margin: 0.25rem;
    img {
      width: 5rem;
      height: 5rem;
    }
  &:first-child{
    margin-left: 0;
  }
  &.small{
    width: 2.5rem;
    height: 2.5rem;
    img {
      width: 2.5rem;
      height: 2.5rem;
    }
  }
  &.large{
    width: 10rem;
    height: 10rem;
    img {
      width: 10rem;
      height: 10rem;
    }
  }
    @media only screen and (max-width: ${breakpoint('md')}) {
    width: 2.5rem;
    height: 2.5rem;
    img {
      width: 2.5rem;
      height: 2.5rem;
    }
    }
  &.rainbow{
    background: radial-gradient(
        circle at top left,
        ${colors('chrome', 0.5)},
        transparent ${rand(50)}%
      ),
      radial-gradient(circle at top right, ${colors(
        'warning',
        0.5
      )}, transparent ${rand(50)}%),
      radial-gradient(at bottom left, ${colors(
        'accent',
        0.5
      )}, transparent ${rand(100)}%),
      radial-gradient(
        at bottom right,
        ${colors('link', 0.5)},
        transparent ${rand(100)}%
      );
  }
`}
`
export const Oobleck = styled(Circle)`
  ${({ max = 80, min = 20, theme: { colors } }) => `
  border-radius: ${[1, 2, 3, 4]
    .map(() => `${Math.floor(Math.random() * (max - min + 1) + min)}%`)
    .join(' ')};
  width: auto;
`}
`

export const Avatar = ({ children, size }) => {
  return <Circle className={size}>{children}</Circle>
}

const AvatarWrap = styled.div`
  position: relative;
  display: inline-flex;
`

const HiddenFileInput = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  overflow: hidden;
`

const EditOverlay = styled.label`
  ${({ theme: { colors } }) => `
  position: absolute;
  right: 0;
  bottom: 0;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: ${colors('chrome')};
  border: 1px solid ${colors('background')};
  &:hover {
    background: ${colors('link', 0.2)};
  }
  `}
`

export const UserAvatar = ({ className, editable, onUploaded, size, user }) => {
  const avatarHandler = async ({ target: { files } }) => {
    if (!files?.[0]) return
    const formData = new FormData()
    formData.append('file', files[0], files[0].name)
    const response = await fetch(
      `${process.env.API_URL}/account/${user.slug}/avatar`,
      {
        method: 'POST',
        body: formData,
        credentials: 'include'
      }
    )
    if (response.ok) onUploaded?.()
  }

  const inputId = `${user?.slug}_avatar_input`

  return (
    <AvatarWrap>
      <Circle className={`${size} ${className}`}>
        {user?.avatar
          ? (
          <img
            src={`https://storage.googleapis.com/pinmonkey-dash/assets/${user.avatar}/asset.webp`}
          />
            )
          : (
          <>{user?.full_name?.[0] || '?'}</>
            )}
      </Circle>
      {editable && (
        <>
          <HiddenFileInput
            id={inputId}
            type="file"
            accept="image/*"
            onChange={avatarHandler}
          />
          <EditOverlay htmlFor={inputId}>
            <Icon icon="pen" width={14} height={14} />
          </EditOverlay>
        </>
      )}
    </AvatarWrap>
  )
}
